{{#each bfms delimeter="\n"}}
function {{ ../abstractBfmHandle.type }} {{ createMethod }}(string name, uvm_component parent);
  return {{ type }}::type_id::create(name, parent);
endfunction
{{/each}}
